'use client';

import '@/libs/syncfusion/telemetry';
import { L10n, registerLicense } from '@syncfusion/ej2-base';

registerLicense(process.env.NEXT_PUBLIC_SYNCFUSION_LICENSE_KEY || '');

L10n.load({
  pt: {
    grid: {
      EmptyRecord: 'Nenhum registro encontrado',
      EmptyDataSourceError: 'Nenhum registro encontrado',
      Search: 'Buscar',
      ColumnChooser: 'Colunas',
      Item: 'item',
      Items: 'itens',
      Of: 'de',
      Page: 'Página',
      ItemsPerPage: 'Linhas por página',
      PagerDropDown: 'Linhas por página',
      PagerAllDropDown: 'Linhas por página',
      TotalItemsInfo: '({0} itens)',
      ClearButton: 'Limpar',
      Clear: 'Limpar',
      ClearFilter: 'Limpar filtro',
    },
    pager: {
      currentPageInfo: '{0} de {1} páginas',
      totalItemsInfo: '({0} itens)',
      itemsPerPage: 'Linhas por página',
      ItemsPerPage: 'Linhas por página',
      pagerDropDown: 'Linhas por página',
      PagerDropDown: 'Linhas por página',
      firstPageTooltip: 'Primeira página',
      lastPageTooltip: 'Última página',
      nextPageTooltip: 'Próxima página',
      previousPageTooltip: 'Página anterior',
      nextPagerTooltip: 'Próximos',
      previousPagerTooltip: 'Anteriores',
    },
  },
});

export function SyncfusionLicense() {
  return null;
}
